import React from 'react';
export function PainPointsSection() {
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-185">
      <div className="max-w-3xl mx-auto" data-id="element-186">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-8 md:mb-12" data-id="element-187">
          Mientras acompañás a los chicos… el tiempo se te escapa
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-188">
          <p data-id="element-189">
            Acompañar a un chico —en casa, en el aula o en el consultorio— es lo
            que más querés hacer bien.
          </p>
          <p data-id="element-190">
            Pero entre rutinas, emociones, atención y actividades, el día se va
            volando.
          </p>
          <p data-id="element-191">
            Y cuando querés sentarte a trabajar algo concreto con ellos, pasa
            esto:
          </p>

          <p className="font-bold text-xl md:text-2xl text-brand-dark bg-brand-light p-4 rounded-lg border-l-4 border-brand-blue" data-id="element-192">
            Buscás material "bueno de verdad" y no encontrás nada que sirva del
            todo.
          </p>

          <p data-id="element-193">
            Terminás descargando cosas sueltas de distintos lados, armando
            actividades a las apuradas, improvisando en el momento… y al final
            del día sentís que no alcanzó.
          </p>

          <div className="bg-orange-50 p-6 rounded-2xl border border-orange-200 text-orange-900 my-8" data-id="element-194">
            <p className="font-bold mb-2" data-id="element-195">
              ⚠️ La semana que viene empieza igual.
            </p>
            <p data-id="element-196">
              Misma búsqueda. Mismo tiempo perdido. Misma sensación de que falta
              algo.
            </p>
          </div>

          <p className="font-bold text-brand-dark" data-id="element-197">No es falta de ganas.</p>
          <p data-id="element-198">
            No es falta de creatividad, ni de esfuerzo, ni de amor por lo que
            hacés.
          </p>
          <p className="font-bold text-brand-blue text-xl" data-id="element-199">
            Es que nunca tuviste un material claro, ordenado y aplicable en un
            solo lugar.
          </p>
        </div>
      </div>
    </section>;
}